import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../context/AuthContext';
import logoNavy from '../../assets/logo-navy.png';

export function SetPassword() {
  const { profile, refreshProfile } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // If password already changed, go to dashboard
  if (profile && profile.password_changed !== false) {
    navigate(`/${profile.role}/dashboard`, { replace: true });
    return null;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (password === 'ApexElite2025!') { setError('Please choose a new password different from the temporary one.'); return; }

    setLoading(true);
    const { error: updateErr } = await supabase.auth.updateUser({ password });
    if (updateErr) { setError(updateErr.message); setLoading(false); return; }

    await supabase.from('profiles').update({ password_changed: true }).eq('id', profile.id);
    await refreshProfile();
    navigate(`/${profile.role}/dashboard`, { replace: true });
  }

  return (
    <div className="auth-screen" style={{ alignItems: 'center', justifyContent: 'center' }}>
      <div className="auth-panel-right" style={{ maxWidth: 480 }}>
        <div className="auth-card">
          <div className="auth-logo">
            <img src={logoNavy} alt="Apex Elite" style={{ height: 40 }} />
          </div>
          <h1 className="auth-title">Set your password</h1>
          <p className="auth-subtitle">
            Welcome to Apex Elite! Choose a personal password to secure your account.
          </p>

          <form className="form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">New Password</label>
              <input
                className="form-input"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Min. 8 characters"
                required
                autoFocus
              />
            </div>
            <div className="form-group">
              <label className="form-label">Confirm Password</label>
              <input
                className="form-input"
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="Re-enter password"
                required
              />
            </div>
            {error && <p className="form-error">{error}</p>}
            <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%' }}>
              {loading ? 'Saving…' : 'Set Password & Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
